import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  LightMode,
} from '@chakra-ui/react';
import Textarea from 'components/Textarea';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DeleteModalProps {
  isOpen: boolean;
  dataHeader: string;
  btnAction: string;
  recordEdit: any;
  action: (_record: any) => void;
  onClose: () => void;
}

const EditModal = ({
  isOpen,
  dataHeader,
  btnAction,
  recordEdit,
  action,
  onClose,
}: DeleteModalProps) => {
  const { t } = useTranslation();
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [value, setValue] = useState('');
  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    if (recordEdit?.name) {
      setValue(recordEdit.name);
    }
  }, [recordEdit?.name]);

  return (
    <>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent
            pos='absolute'
            top='23%'
            color='color_main_text'
            bg='bg_box'
            bgSize={{ base: 'cover', sm: 'initial' }}
          >
            <AlertDialogHeader fontSize='xl'>{dataHeader}</AlertDialogHeader>

            <AlertDialogBody>
              <Textarea
                name='question'
                placeholder='Edit....'
                minH='52px'
                pe={14}
                maxExpandHeight={200}
                value={value}
                onChange={onChange}
                // size={{ base: "70%", sm: "auto" }}
              />
            </AlertDialogBody>

            <AlertDialogFooter>
              <LightMode>
                <Button ref={cancelRef} ml={3} color='black' onClick={onClose}>
                  {t('common.cancel')}
                </Button>
                <Button
                  ml={3}
                  onClick={() => {
                    action({ ...recordEdit, new_name: value });
                    onClose();
                  }}
                  variant='submit'
                >
                  {btnAction}
                </Button>
              </LightMode>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default EditModal;
